/** @file axisAngleQuat: the unit quaternion of a right-handed turn about an axis, in degrees. */
import type { Quat } from '@zilo/pose3d-math/quat/quat';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/** `[a sin(h), cos(h)]` with `a` the normalised axis and `h` half the angle; a zero axis gives the identity. */
export function axisAngleQuat(axis: Vec3, deg: number): Quat {
  const len = Math.hypot(axis[0], axis[1], axis[2]);
  if (len < 1e-12) return [0, 0, 0, 1];
  const h = (deg * Math.PI) / 360;
  const s = Math.sin(h) / len;
  return [axis[0] * s, axis[1] * s, axis[2] * s, Math.cos(h)];
}
